import React, { Component } from 'react';
import Moment from 'moment';
import InputDate from '..//Form/input-date';
import InputRadio from '..//Form/radio';
import InputToggle from '..//Form/toggle';
import Select from '..//Form/select';
import { withTranslation } from "react-i18next";
import lang from 'i18next';



class ModalMessageSimple extends Component {

  constructor(props) {
    super(props);
    this.state = {
      id: props.type,
      show: props.show,
      hidden: 'hidden',
      value: props.value ?? 'both,all,all,false,'+Moment().add(-1, 'month').format('YYYY-MM-YY')+','+Moment().format('YYYY-MM-YY')+',both,both,both,both,both',
      stype: props.stype ?? 'clients',
      type: 'active',
      group: 'all',
      debit: 'all',
      showTime: false,
      date1: Moment().add(-1, 'month').format('YYYY-MM-DD'),
      date2: Moment().format('YYYY-MM-DD'),
      sessions: 'both',
      signups: 'both',
      disconnect: 'both',
      payment: 'both',
      nutrition: 'both',
      groups: [],
      debits: [],
    };
    if(props.show) {
      this.show()
    }
    this.configureData()
  }


  componentWillReceiveProps(props) {
    this.setState({
      id: props.type,
      show: props.show,
      value: props.value ?? 'both,all,all,false,'+Moment().add(-1, 'month').format('YYYY-MM-YY')+','+Moment().format('YYYY-MM-YY')+',both,both,both,both,both',
      stype: props.stype ?? 'clients',
    }, () => {
      if(this.state.show) {
        this.show()
      }
      this.configureData()
    })
  }


  show() {
    this.setState({
      show: true,
    })
    setTimeout(() => {
      this.setState({
        hidden: '',
      });
    }, 100);
  }


  hide() {
    this.setState({
      hidden: 'hidden',
    })
    setTimeout(() => {
      this.setState({show: false});
      this.props.onHide(false);
    }, 500);
  }


  configureData() {
    var tmp1 = [{value: 'all', name: 'All or none'}]
    var tmp2 = [{value: 'all', name: 'All or none'}]
    for(var item1 of global.clientGroups) {
      tmp1.push({value: item1.id, name: item1.data.name})
    }
    for(var item2 of global.products) {
      if(item2.data.type === 'subscription') {
        tmp2.push({value: item2.id, name: item2.data.name})
      }
    }
    var ar = this.state.value.split(',')
    var show = false
    if(ar[3] === 'true') {
      show = true
    }
    this.setState({
      groups: tmp1,
      debits: tmp2,
      type: ar[0],
      group: ar[1],
      debit: ar[2],
      showTime: show,
      date1: ar[4],
      date2: ar[5],
      sessions: ar[6],
      signups: ar[7],
      disconnect: ar[8],
      payment: ar[9],
      nutrition: ar[10],
    })
  }


  updateValues(key, value) {
    this.setState({
      [key]: value
    }, () => {
      var label = this.state.type+','+this.state.group+','+this.state.debit+','+String(this.state.showTime)+','+this.state.date1+','+this.state.date2+','+this.state.sessions+','+this.state.signups+','+this.state.disconnect+','+this.state.payment+','+this.state.nutrition
      this.props.updateFilter(label)
    })
  }


  updateType(event) {
    if(event === 'clients') {
      var label = 'both,all,all,false,'+Moment().add(-1, 'month').format('YYYY-MM-YY')+','+Moment().format('YYYY-MM-YY')+',both,both,both,both,both'
      this.props.updateFilter(label)
    }
    this.props.updateType(event)
  }


  clickMainButton() {
    this.hide()
    this.props.clickMainButton()
  }


  renderTime() {
    if(this.state.showTime) {
      return (
        <div>
          <InputDate label={lang.t('modals:filter.from')} value={this.state.date1} format='YYYY-MM-DD' max={Moment().format('YYYY-MM-DD')} onChange={(event) => this.updateValues('date1', Moment(event).format('YYYY-MM-DD'))}/>
          <InputDate label={lang.t('modals:filter.to')} value={this.state.date2} format='YYYY-MM-DD' max={Moment().format('YYYY-MM-DD')} onChange={(event) => this.updateValues('date2', Moment(event).format('YYYY-MM-DD'))}/>
          <div className="space-10"></div>
          <InputRadio
            label={lang.t('modals:filter.question1')}
            value={this.state.sessions}
            clickElement={(event) => this.updateValues('sessions', event)}
            values={[{name: lang.t('modals:filter.yes'), value: 'yes'}, {name: lang.t('modals:filter.no'), value: 'no'}, {name: lang.t('modals:filter.both'), value: 'both'}]}
          />
          <div className="space-10"></div>
          <InputRadio
            label={lang.t('modals:filter.question2')}
            value={this.state.signups}
            clickElement={(event) => this.updateValues('signups', event)}
            values={[{name: lang.t('modals:filter.yes'), value: 'yes'}, {name: lang.t('modals:filter.no'), value: 'no'}, {name: lang.t('modals:filter.both'), value: 'both'}]}
          />
          <div className="space-10"></div>
          <InputRadio
            label={lang.t('modals:filter.question3')}
            value={this.state.disconnect}
            clickElement={(event) => this.updateValues('disconnect', event)}
            values={[{name: lang.t('modals:filter.yes'), value: 'yes'}, {name: lang.t('modals:filter.no'), value: 'no'}, {name: lang.t('modals:filter.both'), value: 'both'}]}
          />
          <div className="space-10"></div>
          <InputRadio
            label={lang.t('modals:filter.question4')}
            value={this.state.payment}
            clickElement={(event) => this.updateValues('payment', event)}
            values={[{name: lang.t('modals:filter.yes'), value: 'yes'}, {name: lang.t('modals:filter.no'), value: 'no'}, {name: lang.t('modals:filter.both'), value: 'both'}]}
          />
          <div className="space-10"></div>
          <InputRadio
            label={lang.t('modals:filter.question5')}
            value={this.state.nutrition}
            clickElement={(event) => this.updateValues('nutrition', event)}
            values={[{name: lang.t('modals:filter.yes'), value: 'yes'}, {name: lang.t('modals:filter.no'), value: 'no'}, {name: lang.t('modals:filter.both'), value: 'both'}]}
          />
        </div>
      )
    }
  }


  renderForm() {
    if(this.state.stype === 'clients') {
      return (
        <div className="clear scroll">
          <InputRadio
            label={lang.t('modals:filter.sendto')}
            value={this.state.stype}
            clickElement={(event) => this.updateType(event)}
            values={[{name: lang.t('modals:filter.clients'), value: 'clients'}, {name: lang.t('modals:filter.leads'), value: 'leads'}]}
          />
          <InputRadio
            label='Clients'
            value={this.state.type}
            clickElement={(event) => this.updateValues('type', event)}
            values={[{name: lang.t('modals:filter.active'), value: 'active'}, {name: lang.t('modals:filter.inactive'), value: 'inactive'}, {name: lang.t('modals:filter.both'), value: 'both'}]}
          />
          <Select label={lang.t('modals:filter.clientgroup')} value={this.state.group} values={this.state.groups} onChange={(event) => this.updateValues('group', event)}/>
          <Select label={lang.t('modals:filter.membership')} value={this.state.debit} values={this.state.debits} onChange={(event) => this.updateValues('debit', event)}/>
          <InputToggle label={lang.t('modals:filter.daterange')} value={this.state.showTime} onChange={(event) => this.updateValues('showTime', event)} text={lang.t('modals:filter.daterange.text')}/>
          {this.renderTime()}
        </div>
      )
    } else {
      return (
        <div className="clear scroll">
          <InputRadio
            label={lang.t('modals:filter.sendto')}
            value={this.state.stype}
            clickElement={(event) => this.updateType(event)}
            values={[{name: lang.t('modals:filter.clients'), value: 'clients'}, {name: lang.t('modals:filter.leads'), value: 'leads'}]}
          />
        </div>
      )
    }
  }


  render() {
    if(this.state.show) {
      return (
        <div className={'overlay '+this.state.hidden}>
          <div className="box clients">
            <h2 className="mb-20 lft">{lang.t('modals:filter.title')}</h2>
            <button className="btn tertiary small close rgt" onClick={() => this.hide()}>{lang.t('common:button.close')}</button>
            {this.renderForm()}
            <button className="btn primary" onClick={() => this.clickMainButton()}>{lang.t('modals:filter.button')}</button>
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}


export default withTranslation(['modals','common'])(ModalMessageSimple);